import React, { PureComponent } from 'react';
import bindAll from 'lodash.bindall';
import styles from './style.css';

class StepCardLineVideo extends PureComponent {
    constructor(props) {
        super(props);
        bindAll(this, [
            // 'onDrag',
            // 'handleStop',
            // 'showTips'
            'handleClick'
        ]);
    }

    // componentDidMount() {
    //     event.on('NO_TALK', this.noSpeak)
    //     event.on('SPEAKING', this.good)
    // }

    // componentWillReceiveProps(nextProps) {
    //     console.log(nextProps)
    // }

    handleClick(item){
        ModalManager.open(ImgVideoModal, {
            onClose: () => { },
            url:item,
            type:'img'
        })
    }

    render() {
        const { contentVideo } = this.props;

        return (
            <div onClick={contentVideo.video}>
                <video width={contentVideo.width} height={contentVideo.height} src={contentVideo.video}></video>
            </div>
        );
    }
}

export default StepCardLineVideo;
